export const GetStartedBtnLight = '#F6F8FF;';
export const GetStartedBtnDark = '#1F3B9F;';
